import { translate } from '@jsverse/transloco';
export enum Role {
    TECHNICAL = 'TECHNICAL',
    BILLING = 'BILLING',
    ADMIN = 'ADMIN',
    SECURITY = 'SECURITY',
}

export class RoleHelper {
    public static getRoleLocale(mssSUserRole: Role): string {
        switch (mssSUserRole) {
            case Role.TECHNICAL:
                return translate('MSS.SITE.USER_ROLE.TECHNICAL');
            case Role.BILLING:
                return translate('MSS.SITE.USER_ROLE.BILLING');
            case Role.ADMIN:
                return translate('MSS.SITE.USER_ROLE.ADMIN');
            case Role.SECURITY:
                return translate('MSS.SITE.USER_ROLE.SECURITY');
            default:
                return mssSUserRole;
        }
    }
}
